import initializeSwiperCarousel from "./swiper-carousel";
import initSwiperCarousels from "./swiperCarouselBasic";
import initPromotionalBannerSplitLayout from "./promotionalBannerSplitLayout";

const initializeExperienceComponents = () => {
    initializeSwiperCarousel();
    initSwiperCarousels();
    initPromotionalBannerSplitLayout();
};

export default initializeExperienceComponents;
